export default "Holbæk Museum er en del af Museum Vestsjælland. De åbnede deres escape room i juli 2020.";